export default "__VITE_ASSET__DwP$4Pff__"